<template>
    <div class="col-12 mb-3 order-0" :class="{ 'col-lg-6': !isCompanyAccount }">
        <div class="card h-100">
            <div class="d-flex">
                <div class="col-2">
                    <div class="card-body text-elev-blue">
                        <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                </div>
                <div class="col-10">
                    <div class="card-body">
                        <h5 class="text-xl fw-bold" v-if="!isCompanyAccount">{{ $t('Kontosammendrag') }}</h5>
                        <h5 class="text-xl fw-bold" v-else>{{ $t('Avtalesammendrag') }}</h5>
                        <div class="pb-2">

                            <div class="d-flex flex-wrap mb-2 mx-1" v-for="column in accountSummary" :class="column.cssLabel">
                                <div class="col-sm-8 col-6 text-sm">
                                    <span v-html="column.label"></span>
                                </div>
                                <div class="col-sm-4 col-6 text-sm text-end">
                                    {{ formatMoney(column.value) }}
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="isTABS && !isCompanyAccount">
                            <div class="col-12">
                                <a class="btn btn-success btn-block py-2 align-self-end" :href="paymentHref"><strong>{{ $t('Betal nå') }}</strong></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .btn {
        transition: all .2s linear;
        transition-property: background-color, opacity;
    }
</style>

<script setup>
    import {computed} from 'vue';
    import Store from '../../state/accountStore';
    import {toMoney} from "../../lib/format";
    const props = defineProps(['company_contact']);

    const loading = computed(() => Store.isLoading());
    const isCompanyAccount = computed(() => Store.isCompanyAccount())

    // Computed
    const paymentHref = computed(() => {
        if (Store.isVippsEnabled() && window.hasModule('VIPPS')) {
            return '/betaling?metode=vipps'
        }
        return '/betaling';
    })
    const isTABS = computed(() => Store.isTABS());
    const accountSummary = computed(() => Store.getAccountSummary());

    // Methods
    const formatMoney = (amount) => {
        return toMoney(amount);
    };
</script>
